/** Confetti + pop-up sound when a video download finishes. */

const CONFETTI_COLORS = ['#e1f679', '#0066cc', '#28a745', '#ffc107', '#dc3545', '#8b5cf6', '#5C4BD3'];

let celebrationCanvas = null;
let celebrationAnimId = null;

function ensureCelebrationCanvas() {
  if (celebrationCanvas && celebrationCanvas.isConnected) return celebrationCanvas;
  const canvas = document.createElement('canvas');
  canvas.setAttribute('aria-hidden', 'true');
  Object.assign(canvas.style, {
    position: 'fixed',
    inset: '0',
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: '99999',
  });
  document.body.appendChild(canvas);
  celebrationCanvas = canvas;
  return canvas;
}

export function throwDownloadConfetti() {
  if (typeof document === 'undefined') return;
  const canvas = ensureCelebrationCanvas();
  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;

  if (celebrationAnimId) {
    cancelAnimationFrame(celebrationAnimId);
    celebrationAnimId = null;
  }

  const particles = [];
  for (let i = 0; i < 140; i++) {
    particles.push({
      x: Math.random() * canvas.width,
      y: -12 - Math.random() * canvas.height * 0.25,
      width: Math.random() * 10 + 5,
      height: Math.random() * 10 + 5,
      speed: Math.random() * 2.5 + 4.5,
      rotation: Math.random() * 360,
      rotationSpeed: Math.random() * 10 - 20,
      color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
      opacity: Math.random() * 0.45 + 0.55,
    });
  }

  const animate = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      ctx.save();
      ctx.globalAlpha = p.opacity;
      ctx.fillStyle = p.color;
      ctx.translate(p.x, p.y);
      ctx.rotate((p.rotation * Math.PI) / 180);
      ctx.fillRect(-p.width / 2, -p.height / 2, p.width, p.height);
      ctx.restore();
      p.y += p.speed;
      p.x += Math.sin(p.y * 0.01) * 4;
      p.rotation += p.rotationSpeed;
      if (p.y > canvas.height + 24) particles.splice(i, 1);
    }
    if (particles.length > 0) {
      celebrationAnimId = requestAnimationFrame(animate);
    } else {
      celebrationAnimId = null;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
  };
  animate();
}

export function playDownloadPopSound() {
  try {
    const audio = new Audio('/audio/pop_up.m4a');
    audio.volume = 0.45;
    audio.play().catch(() => {});
  } catch (_) {}
}

export function celebrateVideoDownload() {
  throwDownloadConfetti();
  playDownloadPopSound();
}
